export const useStyles = theme => ({
  innerGrid: {
    width: '100%',
    marginTop: '20px',
  },
  squareBoxLastRowCol: {
    borderColor: '#B7B7B7 !important',
    borderStyle: 'solid !important',
    borderBottomWidth: '1px !important',
  },
  squareBoxXAxisCell: {
    position: 'relative',
    border: 'none !important',
    width: '1px',
  },
  squareBoxXAxisLabel: {
    top: '50%',
    border: 0,
    display: 'block',
    padding: 0,
    position: 'absolute',
    transform: 'translate(-47% , -50%) rotate(-90deg)',
    '& span': {
      display: 'block',
      width: '100%',
      textAlign: 'center',
    },
  },
  squareBoxYAxisLabel: {
    // fontWeight: '400 !important',
    textAlign: 'center !important',
    padding: '30px 0px 0px 0px !important',
    fontSize: '16px !important',
    border: 0,
  },
  squareBoxTable: {
    width: '100%',
    marginLeft: 'auto',
    borderCollapse: 'collapse !important',
  },
  squareBox: {
    textAlign: 'center !important',
    borderColor: '#A0750E',
    borderWidth: '1px 0px 1px 1px',
    minWidth: '52px',
    height: '3.4vw',
    padding: '2px 10px !important',
    borderStyle: 'solid',

    '&:last-child': {
      borderRightWidth: '1px',
    },
    [theme.breakpoints.between('md', 'lg')]: {},
  },
  allowToBoxClick: {
    cursor: 'pointer',
  },
  squareBoxRowVal: {
    textAlign: 'center',
    padding: 10,
    border: 0,
    '&.squareBoxColVal': {
      border: 0,
      borderBottomWidth: '0 !important',
      textAlign: 'center',
    },
  },

  tableScrollable: {
    padding: '1px',
    width: '100%',
    overflowX: 'auto',
    overflowY: 'hidden',
    margin: '10px 0 !important',
    position: 'relative',
  },
  customClass: {
    position: 'relative',
    paddingLeft: '35px',
    width: 'auto',
    display: 'inline-block',
    '&:after': {
      content: '"Away Team"',
      position: 'absolute',
      textAlign: 'center',
      width: '100%',
      marginTop: '15px',
      fontWeight: '700',
    },
    '&:before': {
      content: '"Home Team"',
      position: 'absolute',
      fontWeight: '700',
      top: '60%',
      transform: 'rotate(270deg)',
      transformOrigin: 'left',
      marginLeft: 0,
      left: '15px',
    },
  },
  lightColor: {
    backgroundColor: 'rgba(160, 117, 14, 0.25)',
  },
  darkColor: {
    backgroundColor: '#A0750E',
  },
  removeBox: {
    backgroundColor: '#DE0D0D',
    '& svg': {
      fill: '#fff',
    },
  },
  rightBar: {
    padding: '0px 30px',
    [theme.breakpoints.down('sm')]: {
      padding: '0',
    },
  },
  rightBarInner: {
    marginTop: '57px',
    [theme.breakpoints.down('sm')]: {
      marginTop: '0',
      textAlign: 'center',
    },
  },
  heading2: {
    lineHeight: '1 !important',
  },
  LeaderboardHeading: {
    fontSize: '40px',
    fontWeight: '400',
  },
  winnerCellSelected: {
    backgroundColor: '#D9EAD3',
  },
  awayTeam: {
    justifyContent: 'center',
    marginTop: '20px',
  },
});
